export const alliancesData = [
    { src: "/assets/imgs/home/alliances/cars.png", link: "https://www.carso.com.mx/" },
    { src: "/assets/imgs/home/alliances/nestle.png", link: "https://www.nescafe.com/mx/" },
    { src: "/assets/imgs/home/alliances/abengoa.png", link: "https://www.abengoa.com/web" },
    { src: "/assets/imgs/home/alliances/orizaba.png", link: "https://www.orizaba.gob.mx/" },
    { src: "/assets/imgs/home/alliances/ostart.png", link: "https://www.ostar.mx/" },
    { src: "/assets/imgs/home/alliances/scott.png", link: "/" },
];